import {of as observableOf, Observable} from 'rxjs';
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { EventService } from '../services/event.service';
import {first, map} from "rxjs/operators";

export const DonationAmountsResolver: ResolveFn<any> = ( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) : Observable<any>|Promise<any>|any => {

    const eventService = inject(EventService);

    const getFundraiserId = function (route) {
        let isTeam = !!route.queryParams['isTeam'];
        if (isTeam) {
            return eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserId;
        } else {
            return eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserId;
        }
    }

    const isNationalTeamPage = !!route.queryParams['isNationalTeamPage'];
    if(!isNationalTeamPage) {
        return eventService.getDonationAmounts(getFundraiserId(route))
            .pipe(map(res => res.Fundraiser[0].fundraiserDonationAmountRangeTypes)
            ,first());
    } else {
        return observableOf({});
    }
}
